module.exports = __webpack_public_path__ + "img/xzapp.e070fb7e.png";